import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";
import Reveal from "../components/Reveal";

const PHOTOS = Array.from({ length: 10 }, (_, i) => `/site-assets/customer-photos/photo-${i}.png`);

/** The marina's own Customer Photos copy, carried over verbatim -- including the
 *  email address exactly as published. Photos arrive by email or social tag, so
 *  there is no upload widget on the live page and none here. */
export default function CustomerPhotos() {
  return (
    <>
      <Seo
        title="Customer Photos | West Branch Marina"
        description="Share Your Water Adventures with Us."
        path="/customer-photos"
      />

      <PageHero eyebrow="Customer Photos" title="Share Your Water Adventures with Us" />

      <Section tone="white">
        <Reveal>
          <p data-testid="customer-photos-intro" className="max-w-3xl text-base leading-relaxed text-slate-700">
            While you’re out spending the day the water, you’re bound to take a few pictures to remember
            that day years down the road. If you don’t mind, we’d like to remember those days too! Just
            send us your pictures to{" "}
            <a
              href="mailto:westbranchmarina@yahoo.com"
              data-testid="customer-photos-email-link"
              className="font-bold text-ember hover:underline"
            >
              westbranchmarina@yahoo.com
            </a>{" "}
            or tag us on social media. We’ll share your pictures not only on our website, but on our
            social media too!
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PHOTOS.map((src, i) => (
            <Reveal key={src} delay={(i % 3) * 70}>
              <img
                src={src}
                alt={`Customer photo ${i + 1}`}
                data-testid={`customer-photo-${i + 1}`}
                className="h-64 w-full rounded-2xl border border-sand-border object-cover"
                loading="lazy"
              />
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
}
